import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { checkBoundsw7d8y6z7j2xc as checkBounds } from './-Util.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  convertToInty04h231mmjoh as convertToInt,
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { indexOf1i2yqitz2lwb6 as indexOf } from './Segment.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function indexOf_0(_this__u8e3s4, byte, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0n : startIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.v2() : endIndex;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = _this__u8e3s4.v2();
  var endOffset = endIndex <= b ? endIndex : b;
  checkBounds(_this__u8e3s4.v2(), startIndex, endOffset);
  if (startIndex === endOffset)
    return -1n;
  // Inline function 'kotlinx.io.seek' call
  if (_this__u8e3s4.g4e_1 == null) {
    if (-1n === -1n) {
      return -1n;
    }
    var segment = null;
    var offset = -1n;
    do {
      // Inline function 'kotlin.check' call
      if (!(endOffset > offset)) {
        throw IllegalStateException().o('Check failed.');
      }
      ensureNotNull(segment);
      var tmp = segment;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = convertToInt(subtract(startIndex, offset));
      var tmp_0 = Math.max(a, 0);
      var tmp0 = segment.v2();
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = convertToInt(subtract(endOffset, offset));
      var tmp$ret$3 = Math.min(tmp0, b_0);
      var idx = indexOf(tmp, byte, tmp_0, tmp$ret$3);
      if (!(idx === -1)) {
        return add(offset, fromInt(idx));
      }
      var tmp0_0 = offset;
      // Inline function 'kotlin.Long.plus' call
      var other = segment.v2();
      offset = add(tmp0_0, fromInt(other));
      segment = segment.s4e_1;
    }
     while (!(segment == null) && offset < endOffset);
    return -1n;
  }
  if (subtract(_this__u8e3s4.v2(), startIndex) < startIndex) {
    var s = _this__u8e3s4.h4e_1;
    var offset_0 = _this__u8e3s4.v2();
    $l$loop: while (!(s == null) && offset_0 > startIndex) {
      offset_0 = subtract(offset_0, fromInt(s.p4e_1 - s.o4e_1 | 0));
      if (offset_0 <= startIndex)
        break $l$loop;
      s = s.t4e_1;
    }
    var tmp0_1 = s;
    var o = offset_0;
    if (o === -1n) {
      return -1n;
    }
    var segment_0 = tmp0_1;
    var offset_1 = o;
    do {
      // Inline function 'kotlin.check' call
      if (!(endOffset > offset_1)) {
        throw IllegalStateException().o('Check failed.');
      }
      ensureNotNull(segment_0);
      var tmp_1 = segment_0;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_0 = convertToInt(subtract(startIndex, offset_1));
      var tmp_2 = Math.max(a_0, 0);
      var tmp0_2 = segment_0.v2();
      // Inline function 'kotlin.comparisons.minOf' call
      var b_1 = convertToInt(subtract(endOffset, offset_1));
      var tmp$ret$8 = Math.min(tmp0_2, b_1);
      var idx_0 = indexOf(tmp_1, byte, tmp_2, tmp$ret$8);
      if (!(idx_0 === -1)) {
        return add(offset_1, fromInt(idx_0));
      }
      var tmp0_3 = offset_1;
      // Inline function 'kotlin.Long.plus' call
      var other_0 = segment_0.v2();
      offset_1 = add(tmp0_3, fromInt(other_0));
      segment_0 = segment_0.s4e_1;
    }
     while (!(segment_0 == null) && offset_1 < endOffset);
    return -1n;
  } else {
    var s_0 = _this__u8e3s4.g4e_1;
    var offset_2 = 0n;
    $l$loop_0: while (!(s_0 == null)) {
      var tmp0_4 = offset_2;
      // Inline function 'kotlin.Long.plus' call
      var other_1 = s_0.p4e_1 - s_0.o4e_1 | 0;
      var nextOffset = add(tmp0_4, fromInt(other_1));
      if (nextOffset > startIndex)
        break $l$loop_0;
      s_0 = s_0.s4e_1;
      offset_2 = nextOffset;
    }
    var tmp0_5 = s_0;
    var o_0 = offset_2;
    if (o_0 === -1n) {
      return -1n;
    }
    var segment_1 = tmp0_5;
    var offset_3 = o_0;
    do {
      // Inline function 'kotlin.check' call
      if (!(endOffset > offset_3)) {
        throw IllegalStateException().o('Check failed.');
      }
      ensureNotNull(segment_1);
      var tmp_3 = segment_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_1 = convertToInt(subtract(startIndex, offset_3));
      var tmp_4 = Math.max(a_1, 0);
      var tmp0_6 = segment_1.v2();
      // Inline function 'kotlin.comparisons.minOf' call
      var b_2 = convertToInt(subtract(endOffset, offset_3));
      var tmp$ret$13 = Math.min(tmp0_6, b_2);
      var idx_1 = indexOf(tmp_3, byte, tmp_4, tmp$ret$13);
      if (!(idx_1 === -1)) {
        return add(offset_3, fromInt(idx_1));
      }
      var tmp0_7 = offset_3;
      // Inline function 'kotlin.Long.plus' call
      var other_2 = segment_1.v2();
      offset_3 = add(tmp0_7, fromInt(other_2));
      segment_1 = segment_1.s4e_1;
    }
     while (!(segment_1 == null) && offset_3 < endOffset);
    return -1n;
  }
}
//region block: exports
export {
  indexOf_0 as indexOfnhqfh629ytad,
};
//endregion

//# sourceMappingURL=Buffers.mjs.map
